import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import copy from "copy-to-clipboard";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReactTost from "../../ReactTost";

const UserChatBotEmbed = () => {
  const [type, setType] = useState("");
  const { t } = useTranslation();
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [shareUrl, setShareUrl] = useState("");
  const [sharePublicUrl, setPublicShareUrl] = useState("");
  const { id } = useParams();
  const [changeIcon, setChangeIcon] = useState(false);
  const [changeIconData, setchangeIconData] = useState(false);

  useEffect(() => {
    if (id) {
      setPublicShareUrl(`${process.env.REACT_APP_URL}/public-chatbot/${id}`);
    }
  }, [id]);
  const codeSnippetScript = `<script src="${process.env.REACT_APP_API_URL}/v1/bot/script/${id}" defer></script>`;
  useEffect(() => {
    if (id) {
      setShareUrl(`${process.env.REACT_APP_URL}/public-chatbot/${id}`);
    }
  }, [id]);

  function CopyDataScript(e) {
    e.preventDefault();
    copy(codeSnippetScript);
    setchangeIconData(true);
    setTimeout(() => {
      setchangeIconData(false)
    }, 2000);
  }

  function CopyData(e) {
    e.preventDefault();
    copy(shareUrl);
    setChangeIcon(true);
    setTimeout(() => {
      setChangeIcon(false)
    }, 2000);
  }

  return (
    <>
      <ReactTost
        onHide={() => {
          setShowAlert(false);
          setType("");
          setMessage("");
        }}
        alertClass={type}
        alertMessage={message}
        alertDo={showAlert}
      />
      <section className="embed_box">
        <Container>
          <Row className="justify-content-center">
            <Col md={12}>
              <div className="embed_wrap">
                <h2>{t("Embed on site")}</h2>
                {/* <p></p> */}
                <div className="codewrap">
                  <hr className="my-5" />
                  <h4>{t("Script")}</h4>
                  <div className="code_content">
                    <span>
                      {t("To add a chat bubble to the bottom right of your website add this script tag to your html")}
                    </span>
                    <Button
                      className="userbutton my-1"
                      variant="danger"
                      onClick={(e) => {
                        CopyDataScript(e);
                      }}>
                      {t("Copy ")}{changeIconData ? <i className="fa-solid fa-check"></i> : <i className="fa-regular fa-copy"></i>}
                    </Button>
                  </div>
                  <div className="code_box">
                    <code>{codeSnippetScript}</code>
                  </div>
                  <hr className="my-5" />
                  <h4>{t("Share chatbot")}</h4>
                  <div className="code_content">
                    <span>
                      {t("If you share this link, anybody can access your chatbot, independent from the private or public mode under settings. If you want to show your bot on your website, please use embeddings with iframe or with javascript.")}
                    </span>
                    <Button
                      className="userbutton my-1"
                      variant="danger"
                      onClick={(e) => {
                        CopyData(e);
                      }}
                    > {t("Copy")} {changeIcon ? <i className="fa-solid fa-check"></i> : <i className="fa-regular fa-copy"></i>}
                    </Button>
                  </div>
                  <div className="code_box">
                    <code>{sharePublicUrl}</code>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default UserChatBotEmbed;